// extracted by mini-css-extract-plugin
module.exports = {"footer":"Footer_footer__kObrD","footer__item":"Footer_footer__item__hf0GU","footer__link":"Footer_footer__link__HDQvh"};